import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AESEncryptDecryptService } from '../services/aesencrypt-decrypt.service';
import { LocalService } from '../services/local.service';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { ApicallService } from '../services/apicall.service';
import { FlashService } from '../services/flash.service';

@Injectable({
  providedIn: 'root'
})
export class IdleTimerService {
  private inactivityTimeout: any;
  private readonly inactivityThreshold: number = 30 * 60 * 1000; // 15 minutes in milliseconds

  constructor(
    public apiCallService:ApicallService,
    private flashService: FlashService,
    private router:Router,
  ) { }

  startInactivityTimer(): void {
    this.clearInactivityTimeout();
    this.inactivityTimeout = setTimeout(() => this.logOutUser(), this.inactivityThreshold);
  }

  resetInactivityTimer(): void {
    this.clearInactivityTimeout();
    this.startInactivityTimer();
  }

  private clearInactivityTimeout(): void {
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
    }
  }

  private logOutUser(): void {
    // Perform log out logic here (destroy session, clear tokens, etc.)
    this.apiCallService.logout();
    this.flashService.show("Session timeout.", 5000, 'success');
    this.router.navigate(['/']);
    // console.log('User logged out due to inactivity.');
  }
}
